import React, { useState, lazy, Suspense, useEffect, useRef } from "react";

import jetxImage from "../static/img/img-btn-game/jetx.png";
import aviatorImage from "../static/img/img-btn-game/aviator.png";
import rocketman from "../static/img/img-btn-game/rocketman.png";
import plinko from "../static/img/img-btn-game/plinko.png";

import ButtonCategory from "../pages/casino/ButtonCategory.js";

import { useTranslation } from "react-i18next";

import { openGameModal } from "../modal/modal_game";

import UserService from "../../../class/User/UserService.js";
import AuthService from "../../../class/services/AuthService.js";
import Game from "../../../class/Game/Game.js";
import Games from "../../../class/Game_copy/Game.js";

// Динамічне завантаження модального вікна через lazy
const SearchModal = lazy(() => import("../modal/modal_search.js"));

function Navigator({
    handleNavigationChange,
    activePage,
    casinoSections,
    isLogged,
    AuthService,
    setIsLoginModalOpen,
}) {
    const [showSearchModal, setShowSearchModal] = useState(false); // Стан для контролю модального вікна

    const { t } = useTranslation();

    const handleOpenSearchModal = () => setShowSearchModal(true); // Відкрити модальне вікно
    const handleCloseSearchModal = () => setShowSearchModal(false); // Закрити модальне вікно

    const [activeGames, setActiveGames] = useState({});

    const handlePageClick = (pageName) => {
        handleNavigationChange(pageName, "", "");
    };

    const user_id = AuthService.getCustom("user_id") || "";

    const isGameActive = async (gameId) => {
        try {
            const response = await Games.getProviderByGame(gameId, user_id);
            // console.log(response);
            return (
                response.status === "ok" &&
                response.params &&
                Object.keys(response.params).length > 0
            );
        } catch (err) {
            console.error("Errore nel controllo del gioco:", err);
            return false;
        }
    };

    useEffect(() => {
        const checkGames = async () => {
            const ids = [2976, 2978, 2979]; // i tuoi 3 gameId

            const results = {};

            for (const id of ids) {
                results[id] = await isGameActive(id);
            }

            setActiveGames(results);
        };

        checkGames();
    }, []);

    const menuBarRef = useRef(null);

    useEffect(() => {
        const el = menuBarRef.current;
        if (!el) return;

        const handleWheel = (e) => {
            if (e.deltaY !== 0) {
            el.scrollLeft += e.deltaY;
            e.preventDefault();
            }
        };

        el.addEventListener("wheel", handleWheel, { passive: false });
        return () => el.removeEventListener("wheel", handleWheel);
    }, []);


    return (
        <>
            <div>
                <div className="navigation-top main-layout-item">
                    <div id="navigation" className="with-controls">
                        <section className="menu-bar bar" ref={menuBarRef}>
                            <a
                                href="#"
                                className={`menu-bar-item ${activePage === "home" ? "router-link-active router-link-exact-active menu-bar-item" : ""}`}
                                onClick={() => handlePageClick("home")}
                            >
                                <img
                                    alt="Home Icon"
                                    src={"/assets/img/icon-btn/home-icon.png"}
                                    className="HomeSection_icon"
                                />
                                {t("Home")}
                            </a>

                            {casinoSections && casinoSections.sport == 0 && (
                                <a
                                    href="#"
                                    className={`menu-bar-item ${activePage === "sport" ? "router-link-active router-link-exact-active menu-bar-item" : ""}`}
                                    onClick={() => handlePageClick("sport")}
                                >
                                    <img
                                        alt="Sport Icon"
                                        src={
                                            "/assets/img/icon-btn/sport-icon.png"
                                        }
                                        className="HomeSection_icon"
                                    />
                                    {t("Sport")}
                                </a>
                            )}

                            {casinoSections && casinoSections.sport == 0 && (
                                <a
                                    href="#"
                                    className={`menu-bar-item ${activePage === "live" ? "router-link-active router-link-exact-active menu-bar-item" : ""}`}
                                    onClick={() => handlePageClick("live")}
                                >
                                    <img
                                        alt="Live Icon"
                                        src={
                                            "/assets/img/icon-btn/sport-live-icon.png"
                                        }
                                        className="HomeSection_icon"
                                    />
                                    {t("Sport_Live")}
                                </a>
                            )}

                            {/* CATEGORY */}
                            {casinoSections && casinoSections.casino == 0 && (
                                <a
                                    href="#"
                                    className={`menu-bar-item ${activePage === "casino" ? "router-link-active router-link-exact-active menu-bar-item" : ""}`}
                                    onClick={() => handlePageClick("casino")}
                                >
                                    <img
                                        alt="Slot Icon"
                                        src={
                                            "/assets/img/icon-btn/slot-icon.png"
                                        }
                                        className="HomeSection_icon"
                                    />
                                    {t("Slot")}
                                </a>
                            )}

                            {casinoSections &&
                                casinoSections.casino_live == 0 && (
                                    <a
                                        href="#"
                                        className={`menu-bar-item ${activePage === "casino-live" ? "router-link-active router-link-exact-active menu-bar-item" : ""}`}
                                        onClick={() =>
                                            handlePageClick("casino-live")
                                        }
                                    >
                                        <img
                                            alt="Casino Live Icon"
                                            src={
                                                "/assets/img/icon-btn/live-game-icon.png"
                                            }
                                            className="HomeSection_icon"
                                        />
                                        {t("Casino")}
                                    </a>
                                )}

                            {casinoSections &&
                                casinoSections.crash_games == 0 && (
                                    <>
                                        {activeGames[2978] && (
                                            <a
                                                href="#"
                                                onClick={() =>
                                                    openGameModal(2978)
                                                }
                                                className="menu-bar-item"
                                            >
                                                <img
                                                    className="navigation-item-image"
                                                    src="/assets/img/img-btn-game/jetx.png"
                                                    alt="JetX"
                                                    style={{ height: "110%" }}
                                                />{" "}
                                                {/* CUSTOM GAME */}
                                            </a>
                                        )}

                                        {activeGames[2979] && (
                                            <a
                                                href="#"
                                                onClick={() =>
                                                    openGameModal(2979)
                                                }
                                                className="menu-bar-item"
                                            >
                                                <img
                                                    className="navigation-item-image"
                                                    src="/assets/img/img-btn-game/rocketman.png"
                                                    alt="rocketman"
                                                    style={{ height: "110%" }}
                                                />{" "}
                                                {/* CUSTOM GAME */}
                                            </a>
                                        )}

                                        {activeGames[2976] && (
                                            <a
                                                href="#"
                                                className="menu-bar-item"
                                                onClick={() =>
                                                    openGameModal(2976)
                                                }
                                            >
                                                <img
                                                    className="navigation-item-image"
                                                    src="/assets/img/img-btn-game/aviator.png"
                                                    alt="Aviator"
                                                    style={{ height: "110%" }}
                                                />{" "}
                                                {/* CUSTOM GAME */}
                                            </a>
                                        )}
                                    </>
                                )}

                            {/*
            <a href="#" className="menu-bar-item" onClick={() => openGameModal(3239)}>
              <img className="navigation-item-image" src="/assets/img/img-btn-game/plinko.png" alt="Plinko" /> 
            </a>
            */}

                            {/*
            <a href="#" className={`menu-bar-item ${activePage === 'crash-game' ? 'router-link-active router-link-exact-active menu-bar-item' : ''}`}
             onClick={() => handlePageClick('crash-game')}>
              <div className="navigation-item-badge">{t('NEW')}</div>{t('Crash_game')} 
            </a> */}

                            {casinoSections && casinoSections.bingo == 0 && (
                                <a
                                    href="#"
                                    className={`menu-bar-item ${activePage === "bingo" ? "router-link-active router-link-exact-active menu-bar-item" : ""}`}
                                    onClick={() => handlePageClick("bingo")}
                                >
                                    {/* <div className="navigation-item-badge">{t('NEW')}</div> */}{" "}
                                    <img
                                        alt="Bingo Icon"
                                        src={
                                            "/assets/img/icon-btn/bingo-icon.png"
                                        }
                                        className="HomeSection_icon"
                                    />
                                    {t("Bingo")}
                                </a>
                            )}

                            {casinoSections && casinoSections.virtual == 0 && (
                                <a
                                    href="#"
                                    className={`menu-bar-item ${activePage === "virtual" ? "router-link-active router-link-exact-active menu-bar-item" : ""}`}
                                    onClick={() => handlePageClick("virtual")}
                                >
                                    <img
                                        alt="Virtual Icon"
                                        src={
                                            "/assets/img/icon-btn/virtual-icon.png"
                                        }
                                        className="HomeSection_icon"
                                    />
                                    {t("Virtual")}
                                </a>
                            )}

                            {casinoSections &&
                                casinoSections.crash_games == 0 && (
                                    <ButtonCategory
                                        category="crash-game"
                                        name="Crash_game"
                                        activePage={activePage}
                                        handleNavigationChange={
                                            handleNavigationChange
                                        }
                                    />
                                )}
                        </section>
                        {/* <div className="nav-controls">
            <div className="search" onClick={handleOpenSearchModal}>
              <svg
                viewBox="0 0 14 14"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
                className="icon icon-search sm margin square icon"
              >
                <path d="M10.027 8.624c.033.025.064.053.094.083l2.829 2.829a1 1 0 01-1.414 1.414L8.707 10.12a1.01 1.01 0 01-.083-.094 5.5 5.5 0 111.403-1.403zM5.5 9a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"></path>
              </svg>
            </div>
          </div> */}
                    </div>
                </div>

                {/* Використання Suspense для завантаження модального вікна */}
                <Suspense fallback={<div>{t("loading")}...</div>}>
                    {showSearchModal && (
                        <SearchModal
                            show={showSearchModal}
                            handleClose={handleCloseSearchModal}
                            casinoSections={casinoSections}
                            AuthService={AuthService}
                            isLogged={isLogged}
                        />
                    )}
                </Suspense>
            </div>
        </>
    );
}

export default Navigator;
